import React from "react";
import { SearchInputComponent } from "../../../common/components";
import { ServiceListSearchAndFiltersProps } from "./booking-requests-helper";
import { Stack, Badge, Box, Button } from "@mui/material";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import Filter from "./filter";
import "./booking-requests-search-filters.scss";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

type Props = ServiceListSearchAndFiltersProps & {
  /**
   *  NEW (optional):
   * - true  => show search + hint + filter + icons (default)
   * - false => show ONLY list/calendar icons
   */
  showListControls?: boolean;
};

const ServiceListSearchAndFilters: React.FC<Props> = ({
  onSearch,
  onFilterChange,
  onResetFilters,
  filterValues,
  placeholder = "Search by Customer Name, Order ID",
  appliedFiltersCount = 0,
  isFilterOpen = false,
  setIsFilterOpen,
  searchRef,
  isReset = false,
  localSearchText,
  setViewMode,
  viewMode,
  showListControls = true, //  default
}) => {
  return (
    <>
      <div className="search-and-filters-wrapper service-list-search-and-filters-wrapper booking-requests-search-and-filters-wrapper">
        {/*  Search only in list controls */}
        {showListControls && (
          <div className="search-input-wrapper">
            <SearchInputComponent
              placeholder={placeholder}
              onSearch={onSearch}
              ref={searchRef}
              localSearchText={localSearchText}
            />
          </div>
        )}

        {/*  Icons ALWAYS visible */}
        <div
          className={`view-toggle-wrapper ${
            !showListControls ? "view-toggle-wrapper--icons-only" : ""
          }`}
        >
          {/*  Hint only in list controls */}
          {showListControls && (
            <div className="calendar-hint-box">
              <CalendarMonthOutlinedIcon className="calendar-hint-icon" />
              <span>To see orders for specific dates switch to calendar view</span>
            </div>
          )}

          <Box className="view-toggle">
            <Button
              onClick={() => setViewMode("list")}
              variant="text"
              className={`toggle-btn ${viewMode === "list" ? "active" : ""}`}
            >
              <ViewListRoundedIcon />
            </Button>

            <Button
              onClick={() => setViewMode("calendar")}
              variant="text"
              className={`toggle-btn ${viewMode === "calendar" ? "active" : ""}`}
            >
              <CalendarMonthOutlinedIcon />
            </Button>
          </Box>
        </div>

        {/*  Filter only in list controls */}
        {showListControls && (
          <div className="service-list-filter-icon-and-button-wrapper">
            <div
              className="service-list-icon-filter filter-icon-wrapper"
              onClick={() => setIsFilterOpen?.(true)}
              tabIndex={0}
            >
              <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
                <Badge
                  color="secondary"
                  badgeContent={appliedFiltersCount}
                  invisible={appliedFiltersCount === 0}
                >
                  <div className="icon-image-and-text">
                    <img src={FilterIcon} alt="Filter Icon" />
                    Filter
                  </div>
                </Badge>
              </Stack>
            </div>
          </div>
        )}
      </div>

      {/*  Filter modal only in list controls */}
      {showListControls && (
        <Filter
          open={isFilterOpen}
          onClose={() => setIsFilterOpen?.(false)}
          initialValues={filterValues}
          onApply={(filters) => {
            onFilterChange(filters);
          }}
          onReset={() => {
            onResetFilters?.();
          }}
        />
      )}
    </>
  );
};

export default ServiceListSearchAndFilters;
